<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="ofertas.content"
      class="mt-8"
      :loading="loading"
      :server-items-length="ofertas.total"
      @update:options="updateOptions"
      :footer-props="footerOptions"
      no-data-text="Nenhuma oferta encontrada"
      loading-text="Carregando ofertas..."
      :options="optionsList"
    >
      <template v-slot:item.options="{ item }">
        <px-open-oferta is-marketplace :oferta="item.oferta"/>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    ofertas: Object,
    default: [],
    loading: Boolean,
    onChangeOptions: {
      type: Function,
      required: true,
    },
    optionsList: Object,
  },
  data() {
    return {
      footerOptions: {
        itemsPerPageOptions: [5, 10, 15, 20],
        itemsPerPageText: 'Linhas por página',
      },
      headers: [
        {
          text: 'Oferta',
          value: 'oferta.titulo',
          sortable: false,
        },
        {
          text: 'Acessos',
          value: 'quantidadeAcesso',
          sortable: false,
        },
        {
          text: null,
          sortable: false,
          value: 'options',
        },
      ],
    };
  },
  methods: {
    updateOptions(options) {
      this.onChangeOptions(options);
    },
  },
};
</script>
